




































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import TaskDetailMixins from '@/mixins/taskDetail'
import DetailHeaderBtns from '@/components/task/DetailHeaderBtns.vue'
import Tabs from './Tabs.vue'

@Component({
	name: 'mediateTaskDetail',
	components: {
		PageLayout,
		Tabs,
		DetailHeaderBtns,
	},
})
export default class OtherInvestigateDetail extends Mixins(TaskDetailMixins) {}
